import { HierarchyUtils, ComponentIds } from '@inter-ikea-core/core';
import { getComponentEntityMatcher } from './entity-matcher-utils';
import { PlannerProductComponent } from '../components/PlannerProductComponent';
import { hasKvadratComponent } from '@inter-ikea-kvadrat/kvadrat';
import { getSceneManager } from './get-scene-manager';
/**
 * @param {SceneManager | CoreImpl} sceneManagerOrCoreImpl - a scene manager from which to find planner product entities (or an implementation of core)
 * @returns entities in the scene that represent planner products
 */
export const getPlannerProductEntities = (sceneManagerOrCoreImpl) => getComponentEntityMatcher(PlannerProductComponent.id).filterSceneEntities(sceneManagerOrCoreImpl);
export const getAllPlannerEntities = (sceneManagerOrCoreImpl) => {
    return HierarchyUtils.descendants(getSceneManager(sceneManagerOrCoreImpl).scene).filter(e => !hasKvadratComponent(e) &&
        !e.hasComponent(ComponentIds.DRAG_SURFACE_ENTITY_PAIR_CACHE_COMPONENT));
};
//# sourceMappingURL=scene-entity-utils.js.map